import React from 'react';
import { Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const SiteNotFound = React.memo(() => {
  return (
    <Stack>
      <FormattedMessage id="site.notFound" defaultMessage="Site not found" />
    </Stack>
  );
});

export { SiteNotFound };
